import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tabs', 'discussions', 'container', 'input', 'requestBtn', 'formFeedback', 'actions', 'submit']

  connect () {
    this.#checkWindowLocation()
    this.inputTarget.addEventListener('focus', this.#onFocus.bind(this))
    this.inputTarget.addEventListener('blur', this.#onBlur.bind(this))
    this.inputTarget.addEventListener('input', this.#manageSubmitState.bind(this))
  }

  clearInput () {
    this.inputTarget.value = ''
  }

  #checkWindowLocation () {
    if (!this.hasTabsTarget) return

    const location = window.location.href

    if (location.includes('boards')) {
      this.#updateDOM()
      this.#updateClasses()
    }
  }

  #updateDOM () {
    this.tabsTarget.remove()
    this.requestBtnTarget.remove()
  }

  #updateClasses () {
    this.formFeedbackTarget.classList.add('form-feedback_without_tabs')
    if (this.hasDiscussionsTarget) {
      this.discussionsTarget.classList.add('discussions_with_tabs')
    }
    if (this.hasActionsTarget) {
      this.actionsTarget.classList.add('justify-between')
    }
  }

  #onFocus () {
    this.containerTarget.classList.add('border-primary')
    this.containerTarget.classList.remove('border-primary-300')
  }

  #onBlur () {
    this.containerTarget.classList.remove('border-primary')
    this.containerTarget.classList.add('border-primary-300')
  }

  #manageSubmitState () {
    if (this.inputTarget.value.trim() === '') {
      this.#disableSubmit()
    } else {
      this.#enableSubmit()
    }
  }

  #disableSubmit () {
    this.submitTarget.disabled = true
  }

  #enableSubmit () {
    this.submitTarget.disabled = false
  }
}
